var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      staticClass: "modal-container",
      attrs: {
        title: _vm.title,
        width: 800,
        visible: _vm.visible,
        "ok-text": "保存",
      },
      on: { ok: _vm.handleOk, cancel: _vm.hideModal },
    },
    [
      [
        _c(
          "a-form-model",
          {
            ref: "ruleForm",
            attrs: {
              labelCol: _vm.labelCol,
              wrapperCol: _vm.wrapperCol,
              model: _vm.form,
              rules: _vm.rules,
            },
          },
          [
            _c(
              "a-row",
              {
                staticStyle: {
                  "padding-left": "22px",
                  "padding-right": "32px",
                },
                attrs: { gutter: 24 },
              },
              [
                _c(
                  "a-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "a-form-model-item",
                      {
                        attrs: {
                          label: "选择班级",
                          prop: "classId",
                          labelCol: _vm.itemLabelCol,
                          wrapperCol: _vm.itemWrapperCol,
                        },
                      },
                      [
                        _c("j-dict-select-tag", {
                          attrs: {
                            placeholder: "请选择班级",
                            disabled: _vm.isDisabled,
                            identityGet: "classDict",
                            isShowEmpty: false,
                          },
                          on: {
                            select: function ($event) {
                              return _vm.$set(_vm.form, "studentId", undefined)
                            },
                          },
                          model: {
                            value: _vm.form.classId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "classId", $$v)
                            },
                            expression: "form.classId",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "a-form-model-item",
                      {
                        attrs: {
                          label: "选择学生",
                          prop: "studentId",
                          labelCol: _vm.itemLabelCol,
                          wrapperCol: _vm.itemWrapperCol,
                        },
                      },
                      [
                        _c("j-dict-select-tag", {
                          staticClass: "search-space",
                          attrs: {
                            placeholder: "请选择学生",
                            disabled: !_vm.form.classId || _vm.isDisabled,
                            dictCode:
                              "student_info,name,id,class_id=" +
                              (!_vm.form.classId ? -1 : _vm.form.classId),
                            async: true,
                          },
                          model: {
                            value: _vm.form.studentId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "studentId", $$v)
                            },
                            expression: "form.studentId",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "问题原因" } },
              [
                _c("j-dict-select-tag", {
                  attrs: {
                    placeholder: "请选择问题原因",
                    dictCode: "emotional_type",
                    disabled: _vm.isDisabled,
                  },
                  model: {
                    value: _vm.form.tagId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "tagId", $$v)
                    },
                    expression: "form.tagId",
                  },
                }),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "详情描述" } },
              [
                _c("a-textarea", {
                  attrs: {
                    "auto-size": { minRows: 5, maxRows: 8 },
                    placeholder: "请输入内容",
                    disabled: _vm.isDisabled,
                  },
                  model: {
                    value: _vm.form.comment,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "comment", $$v)
                    },
                    expression: "form.comment",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }